export default __webpack_public_path__ + "static/media/background-cover-auth-signup.a237cf3d.png";